import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function PsychometricPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'פסיכומטרי / מכינות – איך לבחור מסגרת',
        metaTitle: 'קורס פסיכומטרי 2025 – כיתות ואונליין | Kursi',
        slug: 'psychometric',
        metaDescription: 'קורסי פסיכומטרי 2025 – כיתות, אונליין, מכינות. מדריך לבחירת קורס הכנה לפסיכומטרי עם סימולציות ומעקב. קבלו 3 המלצות קורסים אישיות.',
        subtitle:
          'הבדל גדול בין קורסים הוא המשמעת: תכנית שבועית, סימולציות, ניתוח טעויות, ומעקב. זה מה שמייצר תוצאות.',
        chips: ['שגרה', 'סימולציות', 'מעקב', 'תגבור'],
        chatSeed: 'פסיכומטרי ומכינות',
        sections: [
          {
            id: 'routine',
            title: 'שגרה מנצחת',
            body:
              'הקורס הכי טוב לא יעזור אם אין שגרה. המסגרת צריכה לייצר לך תרגול קבוע, יעד שבועי, ומעקב.',
            bullets: ['תכנית שבועית', 'יעדים ברורים', 'מעקב ביצועים', 'השלמת פערים'],
          },
          {
            id: 'sims',
            title: 'סימולציות + ניתוח טעויות',
            body:
              'הסוד הוא לא “עוד תרגילים” — אלא ניתוח טעויות עקבי. תבדוק כמה סימולציות יש ומי מנתח אותן איתך.',
            bullets: ['סימולציות תכופות', 'ניתוח טעויות', 'חיזוק נקודות חלשות'],
          },
          {
            id: 'support',
            title: 'מענה ותגבור',
            body:
              'חשוב לדעת איך מקבלים עזרה: זמינות, מענה מסודר, ושיעורי תגבור למתקשים.',
            bullets: ['זמני תגובה ברורים', 'תגבור', 'חומרים מסודרים'],
          },
        ],
        checklist: [
          'כמה סימולציות יש ומה התדירות',
          'איך מנתחים טעויות (ולא רק “ניקוד”)',
          'תכנית שבועית + מעקב',
          'התאמה לרמה שלך',
          'מענה ותגבור מסודר',
        ],
        redFlags: [
          'אין מספיק סימולציות',
          'אין ניתוח טעויות אמיתי',
          'הבטחת “ציון” במקום תהליך',
          'אין התאמה לרמות (כולם יחד)',
        ],
        faq: [
          { q: 'אונליין או פרונטלי?', a: 'אם אתה צריך מסגרת חיצונית – פרונטלי. אם אתה חזק במשמעת – אונליין יכול להספיק.' },
          { q: 'כמה זמן צריך ללמוד?', a: 'תלוי נקודת פתיחה, אבל לרוב שבועות-חודשים. קורס טוב ייתן תכנית מציאותית.' },
        ],
      }}
    />
  );
}
